export function waitForResourcesV1(data) {

  const promises = data.objects.map((object) => {
    return new Promise((resolve) => {
      const type = object.type;
      if (type === 'Image') {
        const image = new Image();
        image.src = object.src;
        image.addEventListener('load', () => {
          resolve();
        });
        image.addEventListener('error', () => {
          resolve();
        });
      } else if (type === 'Video') {
        const video = document.createElement('video');
        video.src = object.src;
        video.addEventListener('loadeddata', () => {
          resolve();
        });
        video.addEventListener('error', () => {
          resolve();
        });
      } else if (type === 'Audio') {
        const audio = new Audio();
        audio.src = object.url;
        audio.addEventListener('loadeddata', () => {
          resolve();
        });
        audio.addEventListener('error', () => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  });

  return Promise.all(promises);

}

export function waitForResources(data) {
  const listeners = {};
  // eslint-disable-next-line func-style
  const notify = (event, ...args) => {
    if (listeners[event]) {
      listeners[event].forEach((callback) => callback(...args));
    }
  };

  // eslint-disable-next-line func-style
  const on = (event, callback) => {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(callback);
    return () => {
      listeners[event] = listeners[event].filter(cb => cb !== callback);
    };
  };

  let loaded = 0;
  const total = data.objects.length;

  const promises = data.objects.map((object) => {
    return new Promise((resolve) => {
      let mediaLoaded = false;
      // Add timeout to prevent hanging resources
      const timeout = setTimeout(() => {
        console.log(`Resource timed out: ${object.src || object.url}`);
        onLoad(); // Mark as loaded after timeout
      }, 10000); // 10 second timeout

      // eslint-disable-next-line func-style
      const onLoad = () => {
        if (mediaLoaded === true) {
          return;
        }
        mediaLoaded = true;
        clearTimeout(timeout); // Clear timeout when loaded normally
        loaded++;
        notify('progress', Math.round((loaded / total) * 100));
        resolve();
      };

      const type = object.type;

      if (type === 'Image') {
        const image = new Image();
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onLoad);
        image.src = object.src;
      } else if (type === 'Video') {
        const video = document.createElement('video');

        // Listen to BOTH these events - one will usually fire
        video.addEventListener('loadeddata', onLoad, { once: true });
        video.addEventListener('canplaythrough', onLoad, { once: true });
        video.addEventListener('error', onLoad, { once: true });

        // Force timeout if stalled
        video.addEventListener('stalled', () => {
          setTimeout(onLoad, 2000); // If stalled, wait 2s then count as loaded
        }, { once: true });

        video.preload = 'auto';
        video.src = object.src;
        video.load(); // Explicitly start loading
      } else if (type === 'Audio') {
        const audio = new Audio();

        // Listen to BOTH these events - one will usually fire
        audio.addEventListener('loadeddata', onLoad, { once: true });
        audio.addEventListener('canplaythrough', onLoad, { once: true });
        audio.addEventListener('error', onLoad, { once: true });

        // Force timeout if stalled
        audio.addEventListener('stalled', () => {
          setTimeout(onLoad, 2000); // If stalled, wait 2s then count as loaded
        }, { once: true });

        audio.preload = 'auto';
        audio.src = object.url || object.src;
        audio.load(); // Explicitly start loading
      } else {
        // For any other type, just mark as loaded
        onLoad();
      }
    });
  });

  Promise.all(promises).then(() => notify('done'));

  return { on };
}